module.exports = __webpack_public_path__ + "static/media/comment-alt.124d5ed6.svg";